import React from 'react'
import Image from 'next/legacy/image'
import styled from 'styled-components'

export const SteveIcon: React.FC<{ size?: number }> = ({ size }) => (
  <IconWrapper size={size}>
    <Image src='/steve.svg' layout='fill' objectFit='cover' alt='인간지능' />
  </IconWrapper>
)

export const GroupbyIcon: React.FC<{ size?: number }> = ({ size }) => (
  <IconWrapper size={size}>
    <Image src='/logo.svg' layout='fill' objectFit='cover' alt='인간지능' />
  </IconWrapper>
)

const IconWrapper = styled.div<{ size?: number }>`
  position: relative;
  width: ${(p) => p.size || 55}px;
  height: ${(p) => p.size || 55}px;
  border-radius: 100%;
  overflow: hidden;
  background-color: ${(p) => p.theme.color.white1};
`
